function getFeatureInfo(feature) {
  const properties = feature.getProperties();
  return Object.entries(properties).filter(
    ([key, value]) => key !== "geometry" && value !== undefined && value !== null
  );
}

function mostrarFeatureInfo(feature, target, content) {
  const rows = getFeatureInfo(feature);
  content.replaceChildren();

  if (rows.length === 0) {
    const empty = document.createElement("p");
    empty.textContent = "Sin atributos disponibles";
    content.appendChild(empty);
  } else {
    const list = document.createElement("dl");

    rows.forEach(([key, value]) => {
      const row = document.createElement("div");
      const term = document.createElement("dt");
      const description = document.createElement("dd");

      row.className = "feature-info__fila";
      term.textContent = key;
      description.textContent = value;

      row.append(term, description);
      list.appendChild(row);
    });

    content.appendChild(list);
  }

  target.classList.add("feature-info--visible");
  target.setAttribute("aria-hidden", "false");
}

function ocultarFeatureInfo(target, content) {
  target.classList.remove("feature-info--visible");
  target.setAttribute("aria-hidden", "true");
  content.replaceChildren();
}

export function configurarInfoFeature(map, targetId = "info") {
  const target = document.getElementById(targetId);
  const content = document.getElementById("info-contenido");
  const closeButton = document.getElementById("info-cerrar");

  if (!target || !content || !closeButton) {
    return;
  }

  closeButton.addEventListener("click", function () {
    ocultarFeatureInfo(target, content);
  });

  window.addEventListener("keydown", function (evt) {
    if (evt.key === "Escape") {
      ocultarFeatureInfo(target, content);
    }
  });

  map.on("pointermove", function (evt) {
    const hit = map.hasFeatureAtPixel(evt.pixel);
    map.getTargetElement().style.cursor = hit ? "pointer" : "";
  });

  map.on("click", function (evt) {
    const feature = map.forEachFeatureAtPixel(evt.pixel, function (feature) {
      return feature;
    });

    if (feature) {
      mostrarFeatureInfo(feature, target, content);
    } else {
      ocultarFeatureInfo(target, content);
    }
  });
}
